<template>
  <div
    id="vehicleOperation-template-setting-window"
    class="template-setting-window"
    style="display: flex"
  >
    <div class="template-setting-window-header">
      <div class="template-setting-window-header-name">
        <strong>Работа ТС</strong><br />
        <small>Настройка отчета</small>
      </div>
      <!-- Картинка крестика-->
      <img
        class="close"
        src="/images/close.png"
        @click="closeHandler"
      />
    </div>

    <div class="overflow-auto">
      <table class="unselectable">
        <tr>
          <td><label for="groupBy">Группировать данные по:</label></td>
          <td>
            <select id="groupBy" class="form-control-sm">
              <option value="day">Дням</option>
              <option value="week">Неделям</option>
              <option value="month">Месяцам</option>
            </select>
          </td>
        </tr>
      </table>
    </div>
    <div class="text-center">
      <span
        class="target-show"
        @mouseenter="(e) => addHoverOnTargetByParent(e)"
        @mouseleave="(e) => removeHoverOnTargetByParent(e)"
      >
        <input
          type="button"
          class="btn btn-primary config-btn-primary btn-sm"
          id="vehicleOperation-template-setting-window-get-template-button"
          value="Выполнить отчет"
          @click="renderReport"
        />
        <span class="target-show-span">Обсчет данных для получения отчета</span>
      </span>
    </div>
  </div>
</template>

<script setup>
import { vehicleOperation_template } from '../../../Template/vehicleOperation/vehicleOperation_template';
import { onMounted, ref } from 'vue';

import {
  addHoverOnTargetByParent,
  removeHoverOnTargetByParent,
} from '@/App/helpers/targetsHelper';

const props = defineProps({
  form_desc: { type: Object, require: true },
  areaId: { type: String, required: true },
});

const emit = defineEmits(['displayReport', 'close']);

const groupBy = ref('week'); // Значение по умолчанию

onMounted(() => {
  const selectElement = document.getElementById('groupBy');
  if (selectElement) {
    selectElement.value = groupBy.value;
  }
});

const renderReport = () => {
  const state = vehicleOperation_template.submit(props.form_desc, callback);
  if (state === 'error') {
    return;
  }

  closeHandler();
};

const callback = (data) => {
    data = data.map((obj) => ({ ...obj, data: JSON.parse(obj.data) }));
    emit('displayReport', { data, areaId: props.areaId });
};

const closeHandler = () => {
  document.getElementById('background-wrap').style.display = 'none';
  emit('close', 'vehicleOperationTemplateSettings');
};
</script>

<style></style>
